<template>
  <div class="CustomeServicePopup">
    <div class="customer-popup-box">
      <div class="customer-popup-title">长按识别关注公众号参与活动</div>
      <img src="http://dreameshop.oss-cn-beijing.aliyuncs.com/22552202111151402359540.jpg">
      <!-- <img src="http://dreameshop.oss-cn-beijing.aliyuncs.com/a907c202111151402355170.jpg"> -->
      <div 
        class="close-popup"
        @click="refresh"
        >我已关注</div>
    </div>
    <div
      class="mask"
      @touchmove.prevent
      @click="close"
    ></div>
  </div>
</template>

<script>
export default {
  name: "FollowPopup",
  props: {
    isPopupShow:{
      type:Boolean,
      default:false
    },
    csPopupMsg:{
      type:Object
    }
  },
  data() {
    return {};
  },
  methods: {
    close: function() {
      this.$emit("closePrePopup", false);
    },
    refresh(){
      this.$emit("refresh")
    }
  }
};
</script>

<style scoped>
.CustomeServicePopup .customer-popup-box{
  position: fixed;
  width: 80%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  text-align: center;
  background: #fff;
  border-radius: .2rem;
  padding-top: .7rem;
  /* padding-bottom: .4rem; */
}
.CustomeServicePopup .customer-popup-box img{
  width: 200px;
}
.CustomeServicePopup .customer-popup-title{
  font-size: .34rem;
  font-weight: 500;
  padding-bottom: .32rem;
}
.CustomeServicePopup .close-popup{
  margin-top: .6rem;
  padding: .4rem 0;
  font-size: .32rem;
  border-top: .02rem solid #e4e4e4;
  color: #576B95;
  font-weight: 700;
}
</style>
